/* eslint-disable*/

import React from "react";
import {useNavigate} from "react-router";
import {Stack, Button, Typography} from "@mui/material";
import styles from "./index.module.scss";
const NotFound = () => {
  const navigate = useNavigate();

  return (
    <main className="flex flex-1 flex-col">
      <div
        className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-background-dark text-white"
        id="a71410ff21ef40ca849826951a88c234">
        <div className="absolute inset-0 z-0">
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{
              margin: "90px 20px 20px 20px",
            }}>
            <iframe
              src="https://lottie.host/embed/da292529-15f7-4185-8cff-56d3f1a2eb06/8tiJi8Fdek.lottie"
              style={{
                border: "none",
                outline: "none",
                width: "100%",
                height: "300px",
              }}
              title="Page Not Found"></iframe>
            <br />
            <br />
            <Typography
              sx={{
                textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                color: "purple",
              }}
              className="fs-45 fw-600">
              “Zoopers - Where fashion is fast”
            </Typography>
            <br />
            <Button
              className={styles.homeBtn}
              variant="contained"
              onClick={() => navigate("/")}>
              Go to Home
            </Button>
          </Stack>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
